const SocialLink = ({ url, icon }) => {
  return (
    <a href={url} target="_blank" rel="noreferrer" className='social-link'>
      {icon}
    </a>
  );
};

export default SocialLink;
